// Tour highlights, testimonials, and FAQs for the Lower East Side tour

export const tourHighlights = [
  {
    title: "Historic Corners",
    description: "Explore a classic gathering spot where neighborhood cats once roamed freely, and glimpse the area's early immigrant life."
  },
  {
    title: "Tales and Taverns",
    description: "Uncover stories of bygone saloons, lively feline mascots, and the people who made this corner of Manhattan so vibrant."
  },
  {
    title: "Music Meets Meow",
    description: "Hear a surprising account of four-legged friends near a legendary music landmark that shaped an entire era."
  },
  {
    title: "Hidden Alley Cats",
    description: "Discover vestiges of old tenements while you learn about local cats, past and present, who found refuge in unlikely places."
  },
  {
    title: "Cat Cafe Finale",
    description: "Our tour concludes near the cat-friendly haven, Meow Parlour. While not included in our tour, you can separately visit this cafe with warm beverages and a chance to meet adoptable kitties (reservation recommended)."
  }
];

// Updated testimonials with Google reviews for LES
export const testimonials = [
  {
    quote: "Really enjoyed my walking tour! Took the FiDi route and learned so much about the history of NYC and the felines who helped it become what it is today! Especially appreciated the happier stories.",
    author: "A.B.",
    role: "NYC history enthusiast"
  },
  {
    quote: "Wonderful tour not only regarding cats but about Brooklyn. Super fun and educated tour leader and the tour group was small so there was much opportunity to ask questions. Tour was also extremely well paced. Highly recommend!",
    author: "Rachel",
    role: "Walking tour enthusiast"
  },
  {
    quote: "You don't have to be a crazy cat person to enjoy this walking tour! Some places I had never visited before; some I knew of, but not the feline history behind. Unique stories amongst the beautiful neighborhood backdrop.",
    author: "DeeAnne G.",
    role: "NYC explorer"
  }
];

export const faqs = [
  {
    question: "What should I bring on the tour?",
    answer: "Comfortable walking shoes, a water bottle, and an umbrella if rain is expected. Don't forget your camera to capture the charming sights and stories of our cat-filled adventure. If you're able to, bring your cat! In a carrier or a backpack. What ever you're comfortable with! Most importantly, bring a curious spirit and love of cats."
  },
  {
    question: "Is the tour suitable for children?",
    answer: "Yes, the tour is family-friendly and suitable for pre-teens and teenagers who will appreciate hearing about the adventurous cats of New York City. However, please note that the tour involves walking for about 2 hours, so ensure everyone is up for the journey."
  },
  {
    question: "What happens if it rains?",
    answer: "The tour will proceed in light rain, so please bring an umbrella or a raincoat. In case of severe weather, we will reschedule or refund your booking to ensure everyone's safety and comfort. We'll notify you via email in advance if the tour is canceled due to bad weather."
  },
  {
    question: "Will we see real cats on the tour?",
    answer: "Our tour primarily focuses on historical cat tales rather than guaranteed live cat sightings. While we occasionally spot neighborhood cats along our route, the heart of our tour is the storytelling about felines from the past. That said, you're welcome to bring your own cat companion along (in a secure harness) to add some modern feline energy to our historical journey!"
  },
  {
    question: "Do I need to book in advance?",
    answer: "Yes, we recommend booking in advance to secure your spot, as tours can fill up quickly. You can easily book your tour through our website."
  },
  {
    question: "Can I take photos during the tour?",
    answer: "Absolutely! Photos are encouraged, but please be respectful and do not use flash photography around the cats. However, we ask that you refrain from taking videos during the tour to ensure the experience is enjoyable for everyone."
  },
  {
    question: "Is there a place to rest during the tour?",
    answer: "Yes, we have a few designated spots where you can sit and rest while enjoying the stories. The cat café at the end of the tour is also a great place to relax and enjoy some refreshments."
  }
];

// FareHarbor booking link and item ID for Lower East Side
export const fareHarborItemId = 604533;
